import { connect } from 'react-redux'
import compose from 'recompose/compose'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'
import StopTitle from '../components/StopTitle'
import { showStopListDrawer } from 'aria-viewer/drawer/drawerMenuActions'

const mapStateToProps = state => {
    const stopIndex = state.getIn(['tour', 'stops', 'current'])
    const stopsList = state.getIn(['tour', 'stops', 'list'])
    const stop = stopsList.get(stopIndex) || {}
    const useResponsiveUI = QueryParamUtils.useResponsiveUI()

    return {
        title: stop.title,
        viewportWidth: state.getIn(['device', 'viewportWidth']),
        viewportHeight: state.getIn(['device', 'viewportHeight']),
        useResponsiveUI,
    }
}

const mapDispatchToProps = dispatch => ({
    onClick: () => {
        dispatch(showStopListDrawer())
    },
})

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(StopTitle)
